import { classnames } from '@aibees/shared/utils';
import { Avatar, AvatarGroup } from '@mui/material';
import { randFullName } from '@ngneat/falso';
import { memo } from 'react';
import { avatars } from './config';
import type { FakeAvatarsGroupProps as Props } from './types';

export const FakeAvatarsGroup = memo(
  ({ className, large, count: size }: Props) => {
    const count = size || 4;

    return (
      <AvatarGroup
        className={classnames('FakeAvatarsGroup', className, { large })}
        max={count}
      >
        {avatars.map((x) => (
          <Avatar key={x} size={32} alt={randFullName()} src={x} />
        ))}
      </AvatarGroup>
    );
  }
);

FakeAvatarsGroup.displayName = 'FakeAvatarsGroup';
